export default __webpack_public_path__ + "static/media/candado_a.cffba3db.png";